import React, { ReactNode } from "react";

import { Button, CircularProgress } from "@mui/material";
import { SxProps, Theme } from "@mui/system";

interface LoadingButtonProps {
  loading: boolean;
  onClick: () => void;
  disabled?: boolean;
  children?: ReactNode;
  icon?: ReactNode;
  sx?: SxProps<Theme>;
}

const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading,
  onClick,
  disabled,
  children,
  icon,
  sx,
}) => {
  return (
    <Button
      variant="text"
      sx={{
        textTransform: "capitalize",
        ...sx,
        p: 1,
        minWidth: 0,
      }}
      color="primary"
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : icon}
    >
      {children}
    </Button>
  );
};

export default LoadingButton;
